import React, { useState, useEffect } from 'react'
import { DocumentDownload } from 'grommet-icons'

import axios from 'axios'
import { Box, Anchor, Text } from "grommet"
import { TopBar } from './TriageViewUtils'

import TTJsonTree from '../common/TTJsonTree'
// import TriagePDF from './TriagePDF'

import { AgGridReact } from 'ag-grid-react';
import { themeBalham } from 'ag-grid-community';

import Warn from '../common/Warn'

// eslint-disable-next-line no-extend-native
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

function findDelimiter(str) {
    const delimiters = [",", ";", "\t", "|"];
    let longestHeaderLength = 0;
    let actualDelimiter = ";";
    
    delimiters.forEach(delimiter => {
        // Split the string using the current delimiter
        const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
        // Check the length of the resulting headers
        if (headers.length > longestHeaderLength) {
            longestHeaderLength = headers.length; // Update longest length
            actualDelimiter = delimiter; // Update actual delimiter
        }
    });
    return actualDelimiter
}

export function csvToArray(str) {
    const delimiter = findDelimiter(str)
    // slice from start of text to the first \n index
    // use split to create an array from string by delimiter
    const headers = str.slice(0, str.indexOf("\n")).split(delimiter);

    // slice from \n index + 1 to the end of the text
    // use split to create an array of each csv value row
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");

    // Map the rows
    // split values from each row into an array
    // use headers.reduce to create an object
    // object properties derived from headers:values
    // the object passed as an element of the array
    const arr = rows.map(function (row) {
        const values = row.split(delimiter);
        const el = headers.reduce(function (object, header, index) {
            object[header] = values[index];
            return object;
        }, {});
        return el;
    });

    // return the array
    return arr;
}

export function DownloadTriageFile(triageFileUrl) {
    const [urlResponse, setUrlResponse] = useState({})

    useEffect(() => {
        const downloadUrl = triageFileUrl
        const fetchAPI = async () => {
            //setUrlResponse({})
            if (downloadUrl) {
                axios.get(
                    downloadUrl
                ).then(response => {
                    setUrlResponse(response)
                }
                ).catch(error => {
                    if (error.name && error.name === "SyntaxError") {
                        setUrlResponse({ "data": error.text })
                    } else {
                        console.log(error)
                        setUrlResponse({ "status": 404 })
                    }
                }
                )
            }
        }
        fetchAPI()
    }, [triageFileUrl])

    return urlResponse;
}

const AgDataGrid = ({ tab_col, tab_data }) => {
    return (
        <Box
            height="100%"
            width="100%"
            pad="small"
        >
            <AgGridReact
                theme={themeBalham}
                columnDefs={tab_col}
                pagination={true}
                defaultColDef={
                    {
                        resizable: true,
                        sortable: true,
                        filter: true,
                        cellStyle: { 'fontSize': '12px', 'fontFamily': "'Metrophobic', sans-serif" },
                        floatingFilter: false,
                    }
                }
                rowData={tab_data}>
            </AgGridReact>
        </Box>
    )
}

const TriageFileText = ({ textFile = '' }) => {
    //console.log(textFile.split("\n"))
    return (
        <Box height="800px">
            <TopBar text={textFile} />
            <Box
                overflow={{ horizontal: 'hidden', vertical: 'auto' }}
                direction="column"
                margin={{ top: "40px" }}
                pad={{ top: '5px', left: '20px', right: '20px', bottom: '5px' }}
                background="black"
            >

                {textFile && textFile.length === 0 &&
                    <Text margin={{ bottom: "4px" }} size='13px' color="accent-1">
                        No Logs To Display
                    </Text>
                }
                {textFile && textFile.length > 0 && textFile.split("\n").map(eachLine => (
                    <Text key={eachLine} margin={{ bottom: "6px" }} size='13px' color="accent-1">{eachLine}</Text>
                ))}
            </Box>
        </Box>
    )
}

const TriageFile = ({ triageFileUrl }) => {

    let triageFileUrlCheck = triageFileUrl.split("?")[0]

    const csvFile = triageFileUrlCheck.endsWith(".csv") ? true : false
    const jsonFile = triageFileUrlCheck.endsWith(".json") ? true : false
    const txtFile = triageFileUrlCheck.endsWith(".txt") ? true : false
    // const pdfFile = triageFileUrl.endsWith(".pdf") ? true : false
    const resultFile = DownloadTriageFile(triageFileUrl)

    const [downloadedFile, setdownloadedFile] = useState(false)

    useEffect(() => {
        if (resultFile && resultFile.data) {
            setdownloadedFile(resultFile.data)
        }
    }, [resultFile, resultFile.data])

    const [tab_data, settab_data] = useState([])
    const [tab_col, settab_col] = useState([])

    useEffect(() => {
        if (downloadedFile && csvFile) {

            let tab_col_temp = []
            let data = csvToArray(downloadedFile)

            if (data.length > 0) {

                // Generate tab_col dynamically
                Object.keys(data[0]).forEach(h => {
                    tab_col_temp.push({
                        field: h,
                        headerName: h.capitalize()
                    })
                })

                settab_col(tab_col_temp)
                settab_data(data)
            }
        }
    }, [downloadedFile, csvFile])

    return (
        <>
            <Anchor icon={<DocumentDownload />}
                label={triageFileUrl}
                key={triageFileUrl} href={triageFileUrl}
                margin={{ top: "10px" }}
            />
            {jsonFile && downloadedFile && Object.keys(downloadedFile).length > 0 &&
                <TTJsonTree data={downloadedFile} expandAll={true} />
            }
            {jsonFile && Object.keys(downloadedFile).length === 0 &&
                <Box pad="medium">
                    <Warn warning="No data has been downloaded" />
                </Box>
            }
            {csvFile && downloadedFile && tab_data.length > 0 &&
                <Box height="1000px">
                    <AgDataGrid
                        tab_col={tab_col}
                        tab_data={tab_data}
                    />
                </Box>
            }
            {csvFile && tab_data.length === 0 &&
                <Box pad="medium">
                    <Warn warning="No data has been downloaded" />
                </Box>
            }

            {txtFile && downloadedFile && downloadedFile.length > 0 && downloadedFile.length > 2000 &&
                <Box pad="medium">
                    <Warn warning="File over 2,000 characters. Preview not shown" subWarning="Please download the file manually using the link above to view" />
                </Box>
            }

            {txtFile && downloadedFile && downloadedFile.length > 0 && downloadedFile.length <= 2000 &&
                <TriageFileText textFile={downloadedFile} />
            }

            {txtFile && downloadedFile && downloadedFile.length === 0 &&
                <Box pad="medium">
                    <Warn warning="No data has been downloaded" />
                </Box>
            }
            {/* {pdfFile &&
                <TriagePDF 
                    triageFileUrl={triageFileUrl}
                />
            } */}
        </>
    )
}

export default TriageFile
